export const AlignmentEnum = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};



// WEBPACK FOOTER //
// ./src/utils/Enums.js